<template>
  <v-container fluid :class="outerClasses">
    <v-layout wrap>
      <v-flex xs12>
        <v-container fluid py-1 px-0 :class="panelContainerClass">
          <v-layout wrap :style="this.paddingStyle + (this.minHeight ? 'min-height: ' + this.minHeight + 'px; ' : '')">
            <v-flex xs12 v-if="title && !(titleRight || linkRight)" class="panelTitle"><div v-html="title"/></v-flex>
            <v-flex xs6 v-if="title && (titleRight || linkRight)" class="panelTitle"><div v-html="title"/></v-flex>
            <v-flex xs6 text-xs-right v-if="titleRight" class="panelTitle"><div v-html="titleRight"/></v-flex>
            <v-flex xs6 text-xs-right v-if="linkRight" class="panelTitle panelTitleLink"><v-icon @click="linkRightClick">launch</v-icon></v-flex>
            <slot/>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Panel',
  props: ['title', 'titleRight', 'minHeight', 'noMargin', 'noMarginTop', 'linkRight', 'noPadding', 'noBorder', 'padding'],
  computed: {
    outerClasses: function () {
      return (this.noMargin === 'true' ? 'container fluid px-0 py-0' : (this.noMarginTop === 'true' ? 'container fluid px-3 py-0' : 'container fluid px-3 py-3'))
    },
    panelContainerClass: function () {
      return (this.noBorder === 'true' ? 'panelContainerNoBorder' : 'panelContainer') + (this.noPadding === 'true' ? ' noPadding' : '')
    },
    paddingStyle: function () {
      return this.noPadding === 'true' ? '' : this.padding ? 'padding: ' + this.padding + ' ' : 'padding: 15px 20px 10px 20px; '
    }
  },
  methods: {
    linkRightClick: function () {
      this.$router.push({name: this.linkRight})
    }
  }
}
</script>

<style scoped>
  .panelContainer {
    background-color: white;
    border: 1px solid #DDDDDD;
    border-radius: 3px;
  }
  .panelContainerNoBorder {
    background-color: white;
  }
  .noPadding {
    padding: 0 !important;
  }
  .panelTitle {
    font-weight: bold;
    font-size: 11pt;
    font-style: normal;
    color: #455A64;
    border-bottom: 1px solid #455A64;
    margin-bottom: 10px;
    height: 22px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Panel.vue